import { IonButton } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import {
  loggedInUserState,
  newAllDropDownState,
  PatientState,
} from "../../data/atoms";
import { ActionType, BusinessType, PatientSetting } from "../../models/Enums";
import { format } from "date-fns";
import {
  getFormatedMobileNumber,
  localDateTime,
  utcToLocalDate,
} from "../../utils/sharedFunction";
import {
  AddUpdateMobileWorkstationPatient,
  GetPatientById,
} from "../../services/AuthServices";
import { PatientVM } from "../../models/PatientVM";

interface Props {
  setShowModal1: Function;
  actionType: ActionType;
  reset?: Function;
  isEdit?: boolean;
}

const PatientExistModal: React.FC<Props> = ({
  setShowModal1,
  actionType: actionTypeProp,
  reset,
  isEdit,
}) => {
  let history = useHistory();
  // Switches to PatientDoesNotExist when "View Patient" returns id -1
  const [actionType, setActionType] = useState<ActionType>(actionTypeProp);

  useEffect(() => {
    setActionType(actionTypeProp);
  }, [actionTypeProp]);

  const [patient, setpatientDetails] = useRecoilState(PatientState);
  let [userToEdit, setuserToEditt] = useRecoilState(loggedInUserState);
  const [patientInfo, setpatientInfo] = useRecoilState(PatientState);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);

  const getDatafromId = (id: number) => {
    if (id == 6) {
      return;
    }
    let LookupId: string = PatientSetting[id] as unknown as string;
    return LookupId;
  };

  async function GetUser() {
    debugger;
    try {
      let patientId = Number(
        localStorage.getItem("patientMasterIDAlreadyExist"),
      );
      const isPatientAlreadyExistFlow =
        localStorage.getItem("isPatientAlreadyExistFlow")?.toLowerCase() ===
        "true";
      var bType = localStorage.getItem("BusinessType") || 1;
      if (Number(bType) === BusinessType.Cloud) {
        await AddUpdateMobileWorkstationPatient({
          PatientId: Number(patientId),
          localDateTime: localDateTime(),
          applicationLookup: 5,
        }).then(async function (response) {
          debugger;
          if (
            response &&
            response?.data &&
            response?.data?.responseCode !== 0
          ) {
            patientId = response?.data.id;
          }
        });
      }
      localStorage.setItem("patientServerID", patientId.toString());

      await GetPatientById({
        PatientId: patientId,
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        IsPatientAlreadyExistFlow: isPatientAlreadyExistFlow,
      })
        .then(async function (response) {
          if (
            response!.data.responseCode !== 0 &&
            Number(response?.data?.patientVM?.id) === -1
          ) {
            setActionType(ActionType.PatientDoesNotExist);
            return;
          }
          if (response!.data.responseCode !== 0) {
            // if (response?.data?.patientVM) {
            //   response.data.patientVM.rtmStartDate = utcToLocalDate(
            //     response.data.patientVM.rtmStartDate,
            //   );
            // }

            localStorage.setItem(
              "patientServerID",
              response?.data?.patientVM?.id,
            );

            setpatientInfo((prevState: PatientVM) => ({
              ...prevState,
              ...response!.data.patientVM,
              referralId: response!.data.patientVM.referralSourceId,
            }));

            setpatientDetails(response!.data.patientVM);

            localStorage.setItem(
              "fullName",
              response!.data.firstName + " " + response!.data.lastName,
            );

            setShowModal1(false);

            reset?.({
              firstname: response!.data.patientVM!?.firstName,
              lastname: response!.data.patientVM!?.lastName,
              nickname: response!.data.patientVM!?.nickName,
              dob: response!.data.patientVM!?.dob,
              email: response!.data.patientVM!?.email,
              zipcode: response!.data.patientVM!?.zip,
              mrn: response!.data.patientVM!?.mrn,
              phone: getFormatedMobileNumber(
                response!.data.patientVM!?.mobilePhone!,
              ),
              setting: getDatafromId(response!.data.patientVM!?.patientSetting),
              referral: response!.data.patientVM!?.referralId!,
              physician: response!.data.patientVM!?.physicianId,
              department: response!.data.patientVM!?.departmentId,
              testPatient: false,
              dobFormatted:
                response!.data.patientVM?.dob == undefined ||
                patient?.isNew == true
                  ? ""
                  : format(
                      new Date(response!.data.patientVM?.dob),
                      "MM/dd/yyyy",
                    ),
            });

            history.replace("/patient-page", { props: true });
            return;
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }
  }

  return (
    <div className="overall-center-modal">
      <div className="generic-modal-main-wrap">
        <div className="icon-sec text-center">
          {/* Patient Already Exit SVG */}
          {(actionType === ActionType.PatientAlreadyExist ||
            actionType === ActionType.PatientDoesNotExist) && (
            <svg
              width="90"
              height="102"
              viewBox="0 0 90 102"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M45.1245 51C51.8875 51 58.3736 48.3134 63.1557 43.5312C67.9379 38.749 70.6245 32.263 70.6245 25.5C70.6245 18.737 67.9379 12.251 63.1557 7.46878C58.3736 2.6866 51.8875 0 45.1245 0C38.3615 0 31.8755 2.6866 27.0933 7.46878C22.3111 12.251 19.6245 18.737 19.6245 25.5C19.6245 32.263 22.3111 38.749 27.0933 43.5312C31.8755 48.3134 38.3615 51 45.1245 51ZM36.0202 60.5625C16.3972 60.5625 0.499512 76.4602 0.499512 96.0832C0.499512 99.3504 3.14912 102 6.41631 102H83.8327C87.0999 102 89.7495 99.3504 89.7495 96.0832C89.7495 76.4602 73.8519 60.5625 54.2288 60.5625H36.0202Z"
                fill="#802392"
              />
            </svg>
          )}
          {/* Patient Already Exit SVG */}
        </div>

        <div className="generic-modal-text">
          {actionType === ActionType.PatientAlreadyExist && (
            <>
              <h1>Error</h1>
              <p>This patient already exists.</p>
            </>
          )}
          {actionType === ActionType.PatientDoesNotExist && (
            <>
              <h1>Error</h1>
              <p>This patient does not exist.</p>
            </>
          )}
        </div>

        {actionType === ActionType.PatientDoesNotExist && (
          <div className="generic-modal-btn-wrap text-center">
            <IonButton
              className="generic-btn w-50"
              placeholder={undefined}
              onClick={() => {
                setShowModal1(false);
                history.push("/home");
              }}
            >
              Back to Home
            </IonButton>
          </div>
        )}

        {actionType !== ActionType.PatientDoesNotExist && (
        <div className="generic-modal-btn-wrap two-btns">
          <ul>
            {actionType === ActionType.PatientAlreadyExist && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    setShowModal1(false);
                  }}
                >
                  Back
                </IonButton>
              </li>
            )}

            {(actionType === ActionType.PatientAlreadyExist ||
              actionType === ActionType.CreateNewPatient ||
              actionType === ActionType.NewUser ||
              actionType === ActionType.ForgotPassword) && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={() => {
                    GetUser();
                  }}
                >
                  View Patient
                </IonButton>
              </li>
            )}
          </ul>
        </div>
        )}
      </div>
    </div>
  );
};

export default PatientExistModal;
